import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5" }
const _hoisted_2 = { class: "container mx-auto block w-full mt-4 space-y-4" }
const _hoisted_3 = { class: "w-full flex flex-col font-normal text-lg text-green-800 bg-green-100 border rounded-lg shadow-sm p-2 mt-3" }
const _hoisted_4 = { class: "container mx-auto block w-full" }
const _hoisted_5 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_6 = { class: "w-full px-2" }
const _hoisted_7 = { class: "text-sm text-red-500 p-error" }
const _hoisted_8 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_9 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_10 = { class: "text-sm text-red-500 p-error" }
const _hoisted_11 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_12 = { class: "text-sm text-red-500 p-error" }
const _hoisted_13 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_14 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_15 = { class: "text-sm text-red-500 p-error" }
const _hoisted_16 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_17 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_18 = { class: "text-sm text-red-500 p-error" }
const _hoisted_19 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_20 = { class: "text-sm text-red-500 p-error" }
const _hoisted_21 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_22 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_23 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_24 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_25 = { class: "text-sm text-red-500 p-error" }
const _hoisted_26 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_27 = { class: "text-sm text-red-500 p-error" }
const _hoisted_28 = { class: "flex flex-wrap py-2 gap-2" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_31 = { class: "pi pi-check mr-2" }
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Form = _resolveComponent("Form")!
  const _component_CommonPrivateView = _resolveComponent("CommonPrivateView")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CommonPrivateView, null, {
      header: _withCtx(() => _cache[11] || (_cache[11] = [
        _createElementVNode("div", { class: "w-full flex flex-row py-6 text-white font-bold uppercase text-2xl [text-shadow:_2px_2px_0_rgb(155_155_155_/_60%)]" }, " Asignar invitación ", -1)
      ])),
      content: _withCtx(() => [
        _createVNode(_component_Form, {
          onSubmit: _ctx.onSubmit,
          class: "w-full",
          "validation-schema": _ctx.schema,
          onInvalidSubmit: _ctx.onInvalidSubmit
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "flex items-center justify-between font-semibold text-lg" }, " INVITACIONES ", -1)),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _cache[12] || (_cache[12] = _createTextVNode("Grupo ")),
                    _createElementVNode("b", null, _toDisplayString(_ctx.grupoInvitacion?.descripcion), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[13] || (_cache[13] = _createTextVNode("Código de invitación ")),
                    _createElementVNode("b", null, _toDisplayString(_ctx.invitacion?.codigoInvitacion), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block mb-1" }, "Mail (*)", -1)),
                      _createVNode(_component_Field, {
                        name: "mail",
                        modelValue: _ctx.formData.mail,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.mail) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "mail",
                            placeholder: "Mail",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_7, [
                            _createVNode(_component_ErrorMessage, { name: "mail" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block mb-1" }, "Nombre (*)", -1)),
                      _createVNode(_component_Field, {
                        name: "nombre",
                        modelValue: _ctx.formData.nombre,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.nombre) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: "Nombre",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_10, [
                            _createVNode(_component_ErrorMessage, { name: "nombre" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block mb-1" }, "Apellido (*)", -1)),
                      _createVNode(_component_Field, {
                        name: "apellido",
                        modelValue: _ctx.formData.apellido,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.apellido) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: "Apellido",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_12, [
                            _createVNode(_component_ErrorMessage, { name: "apellido" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block mb-1" }, "DNI / Pasaporte (*)", -1)),
                      _createVNode(_component_Field, {
                        name: "documento",
                        modelValue: _ctx.formData.documento,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.documento) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "numeric",
                            placeholder: "Documento / Pasaporte",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_15, [
                            _createVNode(_component_ErrorMessage, { name: "documento" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block mb-1" }, "Empresa (Opcional)", -1)),
                      _createVNode(_component_Field, {
                        name: "empresa",
                        modelValue: _ctx.formData.empresa,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.empresa) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: "Empresa",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_18, [
                            _createVNode(_component_ErrorMessage, { name: "empresa" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block mb-1" }, "Cargo (Opcional)", -1)),
                      _createVNode(_component_Field, {
                        name: "cargo",
                        modelValue: _ctx.formData.cargo,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.cargo) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: "Cargo",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_20, [
                            _createVNode(_component_ErrorMessage, { name: "cargo" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block mb-1" }, "País", -1)),
                      _createVNode(_component_Dropdown, {
                        modelValue: _ctx.selectedCountry,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCountry) = $event)),
                        options: _ctx.paises,
                        optionLabel: "descripcion",
                        placeholder: "Seleccione un país",
                        class: "input-base"
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block mb-1" }, "Cód. país", -1)),
                      (_ctx.selectedCountry !== null)
                        ? (_openBlock(), _createBlock(_component_InputText, {
                            key: 0,
                            type: "text",
                            modelValue: _ctx.selectedCountry.id,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedCountry.id) = $event)),
                            class: "input-base",
                            readonly: ""
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block mb-1" }, "Cód. área", -1)),
                      _createVNode(_component_Field, {
                        name: "codigoArea",
                        modelValue: _ctx.formData.codigoArea,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.codigoArea) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_25, [
                            _createVNode(_component_ErrorMessage, { name: "codigoArea" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block mb-1" }, "Teléfono (Opcional)", -1)),
                      _createVNode(_component_Field, {
                        name: "telefono",
                        modelValue: _ctx.formData.telefono,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.telefono) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_27, [
                            _createVNode(_component_ErrorMessage, { name: "telefono" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
                      disabled: _ctx.isSubmitting
                    }, [
                      _withDirectives(_createElementVNode("i", _hoisted_30, null, 512), [
                        [_vShow, _ctx.isSubmitting]
                      ]),
                      _withDirectives(_createElementVNode("i", _hoisted_31, null, 512), [
                        [_vShow, !_ctx.isSubmitting]
                      ]),
                      _cache[24] || (_cache[24] = _createTextVNode("ACEPTAR "))
                    ], 8, _hoisted_29),
                    _createElementVNode("button", {
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.cancelarAlta && _ctx.cancelarAlta(...args))),
                      class: "mt-4 px-4 py-2 bg-transparent border-red-700 hover:bg-red-700 text-red-700 font-semibold hover:text-white border rounded",
                      disabled: _ctx.isSubmitting
                    }, _cache[25] || (_cache[25] = [
                      _createElementVNode("i", { class: "pi pi-times mr-2" }, null, -1),
                      _createTextVNode("CANCELAR ")
                    ]), 8, _hoisted_32)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"])
      ]),
      _: 1
    }),
    _createVNode(_component_BlockUI, {
      blocked: _ctx.isSubmitting,
      fullScreen: ""
    }, null, 8, ["blocked"])
  ], 64))
}